export enum BillingStatusEnum {
  DRAFT = 'Draft',
  READY_FOR_REGISTRATION = 'ReadyForRegistration',
  NEW = 'New',
  PREPARED = 'Prepared',
  CANCELLED = 'Cancelled',
  SENT_TO_RECIPIENT = 'SentToRecipient',
  DELIVERY_TO_RECIPIENT_FAILED = 'DeliveryToRecipientFailed',
  DELIVERED_TO_RECIPIENT = 'DeliveredToRecipient',
  OPENED_BY_RECIPIENT = 'OpenedByRecipient',
  SENT_TO_ACQUIRER = 'SentToAcquirer',
  CONFIRMED_BY_SALESMAN = 'ConfirmedBySalesman',
  CONFIRMED_BY_ACQUIRER = 'ConfirmedByAcquirer',
  DECLINED_BY_ACQUIRER = 'DeclinedByAcquirer',
  DECLINED_BY_ACQUIRER_ATTEMPT = 'DeclinedByAcquirerAttempt',
  PAID = 'Paid',
  EXPIRED = 'Expired',
}

export const availableSuccessStatusOfBilling: BillingStatusEnum[] = [
  BillingStatusEnum.PAID,
  BillingStatusEnum.CONFIRMED_BY_ACQUIRER,
  BillingStatusEnum.CONFIRMED_BY_SALESMAN,
];

export const availableFailureStatusOfBilling: BillingStatusEnum[] = [
  BillingStatusEnum.CANCELLED,
  BillingStatusEnum.DELIVERY_TO_RECIPIENT_FAILED,
  BillingStatusEnum.DECLINED_BY_ACQUIRER,
  BillingStatusEnum.DECLINED_BY_ACQUIRER_ATTEMPT,
  BillingStatusEnum.EXPIRED,
];

export const availableProgressStatusOfBilling: BillingStatusEnum[] = [
  BillingStatusEnum.DRAFT,
  BillingStatusEnum.READY_FOR_REGISTRATION,
  BillingStatusEnum.NEW,
  BillingStatusEnum.PREPARED,
  BillingStatusEnum.SENT_TO_RECIPIENT,
  BillingStatusEnum.DELIVERED_TO_RECIPIENT,
  BillingStatusEnum.OPENED_BY_RECIPIENT,
  BillingStatusEnum.SENT_TO_ACQUIRER,
];
